import { API_BASE } from '../components/config';
import { apiJson } from '../utils/apiFetch';

const entries = new Map();
const CACHE_MS = 2500;

export function invalidateAdminAlerts(groupId) {
  const entry = entries.get(Number(groupId));
  if (entry) entry.updatedAt = 0;
}

export function loadAdminAlerts(groupId, { force = false } = {}) {
  const id = Number(groupId);
  if (!id) return Promise.resolve({ matchRequests: [], waitAlerts: [] });

  const current = entries.get(id) || { data: null, updatedAt: 0, promise: null };
  const isFresh = Date.now() - current.updatedAt < CACHE_MS;

  if (!force && current.data && isFresh) return Promise.resolve(current.data);
  if (current.promise) return current.promise;

  current.promise = apiJson(`${API_BASE}/api/match-planner/${id}/admin-alerts`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token') || ''}` }
  }).then(result => {
    current.data = {
      matchRequests: result.matchRequests || [],
      waitAlerts: result.waitAlerts || []
    };
    current.updatedAt = Date.now();
    return current.data;
  }).finally(() => {
    current.promise = null;
  });

  entries.set(id, current);
  return current.promise;
}
